import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the #hash target when there is one (e.g. "How I work" -> /#how), otherwise to the top on every route change.
const ScrollToTop = (props) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const target = hash && document.getElementById(decodeURIComponent(hash.slice(1)));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname, hash]);

  return <>{props.children}</>;
};

export default ScrollToTop;
